<dx-popup
  [width]="'500px'"
  [(visible)]="showModal"
  [height]="'auto'"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
>
  <div class="popup-content">
    <h1 class="title">{{ "SUBSCRIPTIONS.REMOVE-SUBSCRIBER.TITLE" | translate }}</h1>
    <p class="description">{{ "SUBSCRIPTIONS.REMOVE-SUBSCRIBER.TEXT" | translate }}</p>
    <p>{{ "SUBSCRIPTIONS.REMOVE-SUBSCRIBER.DISCLAIMER" | translate }}</p>
    <div class="button-container">
      <dx-button 
        [text]="'COMMON.CANCEL' | translate" 
        type="danger"
        stylingMode="contained"
        [width]="'175px'"
        (onClick)="cancel()"
      ></dx-button>
      <dx-button 
        [text]="'COMMON.REMOVE' | translate" 
        type="normal"
        stylingMode="contained"
        [width]="'175px'"
        (onClick)="remove()"
      ></dx-button>
    </div>
  </div>
</dx-popup>